export const BASE_COLOR = '#a4cea0';
export const CONTRAST_COLOR = '#3a4044';

export const LOGIN_PATH = 'inloggen';
export const LOGIN_ROUTE = `/${LOGIN_PATH}`;
export const WAIT_LIST_PATH = 'wachtlijst';
export const WAIT_LIST_ROUTE = `/${WAIT_LIST_PATH}`;